
import { useQuery } from "@tanstack/react-query";
import { getPublicPetsByCategory, getPetCategoryCounts } from "../services/categoryService";

export function usePublicPetsByCategory(category?: string) {
  return useQuery({
    queryKey: ['public-pets', category],
    queryFn: () => getPublicPetsByCategory(category),
  });
}

export function usePetCategoryCounts() {
  return useQuery({
    queryKey: ['pet-category-counts'],
    queryFn: getPetCategoryCounts,
  });
}
